'use strict';
module.exports = require('../../full/instance/map');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/map.js
// module id = 597
// module chunks = 13